import ClassCountModule from "./classCountModule";
import ClassCountReducer from "./redux/classCountReducer";
import ClassCountSaga from "./redux/classCountSagas";

export default {
  Component: ClassCountModule,
  moduleName: "classCount",
  saga: ClassCountSaga(),
  reducer: ClassCountReducer
};
